/**
 * Minimal mock data for fallback scenarios only
 * 
 * Categories are now fetched from the database via useCategories hook
 * Product type is centralized in @/types/product
 * 
 * This file only contains minimal mock product data for:
 * - Development when database is unavailable
 * - Error states in useProducts.ts and ProductDetail.tsx
 * - Initial loading states
 */

import { Product } from '@/types/product';

export const mockProducts: Product[] = [
  {
    id: "trem-group",
    slug: "trem-group",
    title: "TREM Group",
    subtitle: "Luxury real estate websites and lead gen",
    description: "Custom IDX sites paired with paid traffic and conversion funnels.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop"
    ],
    price: 0,
    msrp: 0,
    price_duration: "mo",
    rating: 4.9,
    review_count: 27,
    categories: ["websites", "lead-generation"],
    tags: ["IDX Websites", "Lead Generation"],
    is_select: true,
    is_hot: false,
    features: [
      "Custom IDX website design",
      "Paid traffic management",
      "Conversion funnels",
      "CRM integration"
    ],
    is_published: true,
    service_type: 'service',
    best_for: ["Team Leaders", "Luxury Agents"],
    integrations_text: "Zapier, Google Calendar, Follow Up Boss",
    integration_tags: ["Zapier", "Google Calendar", "Follow Up Boss"],
    plans: [
      {
        name: "Basic",
        price: 0,
        features: ["Custom consultation"]
      }
    ],
    reviews: []
  }
];
